export const PAGE_SIZE = 12

export const MODE = {
    UNVOTED: 'unvoted',
    REJECTED: 'rejected',
    ACCEPTED: 'accepted'
}

export const MODES = [
    MODE.UNVOTED,
    MODE.REJECTED,
    MODE.ACCEPTED
]

export const BATCH_MODE = {
    rejectAll: 'rejectAll',
    acceptAll: 'acceptAll'
}
